export interface ServiceSubscriptionsResponse {
  activeSubscriptionTypes: SubscriptionType[];
  blockingSubscriptionExist: boolean;
}

export enum SubscriptionType {
  Internet = 'Internet',
  Tv = 'TV',
  Phone = 'Telefoni',
}
